import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="float-menu"
export default class extends Controller {
  static targets = [ 'menu' ]

  toggle(event) {
    if (!this.hasMenuTarget) {
      return;
    }
    const menu = this.menuTarget;

    // 元の親と次に来る兄弟ノードを記憶
    const originalParent = menu.parentNode;
    const originalNextSibling = menu.nextSibling;

    // クリックしたリンクの直下に表示
    const rect = event.currentTarget.getBoundingClientRect();
    document.body.appendChild(menu)
    menu.style.display = "block";
    menu.style.position = "absolute";
    // menu.style.top = `${rect.bottom + window.scrollY}px`;
    menu.style.left = `${rect.left + window.scrollX}px`;

    const showAbove = rect.bottom > window.innerHeight * 0.7;
    if (showAbove) {
      // 上方向に表示
      menu.style.bottom = `${window.innerHeight - rect.top - window.scrollY}px`;
      menu.style.top = ''; // 念のためリセット
    } else {
      // 下方向に表示
      menu.style.top = `${rect.bottom + window.scrollY}px`;
      menu.style.bottom = ''; // 念のためリセット
    }

    // 外側クリック検出用のリスナー追加
    const hideFloatMenu = (e) => {
      menu.style.display = 'none';
      // 元の場所に戻す
      if (originalNextSibling) {
        originalParent.insertBefore(menu, originalNextSibling);
      } else {
        originalParent.appendChild(menu);
      }
      document.removeEventListener('click', hideFloatMenu);
    };

    // 非同期にしないと「表示直後のクリックイベント」が拾われてしまう
    setTimeout(() => {
      document.addEventListener('click', hideFloatMenu);
    }, 100);
  }
}
